export default "__VITE_ASSET__0a479efe__"